import {
  genericCallWithBodyAndResponseDecoded,
  genericCallWithOutBody,
  genericCallWithParametersNoEncrypted,
  genericGetWithBody,
  genericGetWithParameters,
} from './Networking'

export async function saveOrder(objOrder) {
  const method = 'POST'
  const apiName = 'BNOrder/SaveOrder'

  const response = await genericCallWithBodyAndResponseDecoded(
    method,
    apiName,
    objOrder,
  )
  return response
}

export async function updateOrder(objOrder) {
  const method = 'POST'
  const apiName = 'BNOrder/UpdateOrder'

  const response = await genericCallWithBodyAndResponseDecoded(
    method,
    apiName,
    objOrder,
  )
  return response
}

export async function getOrderFee(
  customerID,
  totalOrder,
  lockedSide,
  settlementccy
) {
  try {
    const params = {
      customerID: customerID,
      amount: totalOrder,
      buysell: lockedSide,
      settlementccy: settlementccy
    }
    const response = await genericGetWithParameters('Rate/GetOrderFee', params)

    return response
  } catch (error) {
    console.error(error)
  }
}

export async function getOrderConfirmation(orderID) {
  try {
    const params = {
      orderID: orderID,
    }
    const response = await genericGetWithParameters(
      'BNOrder/GetOrderConfirmation',
      params,
    )
    return response
  } catch (error) {
    console.error(error)
  }
}

export async function getBNVaultBalances(params = {}) {
  try {
    const response = await genericGetWithParameters('BNOrder/GetBNVaultBalances', params);
    return response;
  } catch (error) {
    console.error(error)
  }
}

export async function getBNVaults() {
  try {
    const response = await genericGetWithParameters('BNOrder/GetBNVaults', {});
    return response
  } catch (error) {
    console.log(error)
  }
}

export async function BNVaultBalancesGetTotals() {
  try {
    let params = {}
    let response = await genericGetWithParameters('BNOrder/BNVaultBalancesGetTotals', params);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function getBNClosingBalances(params = {}) {
  try {
    let response = await genericGetWithParameters('BNOrder/GetClosingBalances', params);
    return response;
  } catch (e) {
    console.error(e)
  }
}

export async function getOrderInfo(orderID) {
  try {
    let params = {
      'orderNumber': orderID
    }

    let response = await genericGetWithParameters('BNOrder/GetBankNoteOrder', params);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function DefaultReconciliation(request){
  try {
      const response = await genericCallWithBodyAndResponseDecoded('POST','BNOrder/DefaultReconciliation',request);

      return response;
  } catch (error) {
      console.error(error);
  }
}

export async function BNPrintLabel(request){
  try {
      const response = await genericCallWithBodyAndResponseDecoded('POST','BNOrder/PrintLabel',request);
      return response;
  } catch (error) {
      console.error(error);
  }
}

export async function getDeliveryFee(customerID, totalOrder, lockedSide, deliveryFeeID, settlementCcy) {
  try {
    const params = {
      customerID: customerID,
      amount: totalOrder,
      buysell: lockedSide,
      deliveryfeeid: deliveryFeeID,
      settlementCcy: settlementCcy
    }
    const response = await genericGetWithParameters('Rate/GetDeliveryFee', params)

    return response
  } catch (error) {
    console.error(error)
  }
}

export const sendOrderConfirmation = async (orderNumber) => {
    var method = 'POST';
    var apiName = 'BNOrder/SendOrderConfirmationEmail'
    try {
        let response = await genericCallWithBodyAndResponseDecoded(method, apiName, {
            'OrderID': orderNumber
        });
        return response;
    } catch (error) {
        console.error(error)
    }
}

export async function shippingConfirmationValidation(token){
  const params = {
    validationRequestID: token
  } 
  try {
    const response = await genericCallWithOutBody('BNOrder/ShippingConfirmationValidation', params);
    return response;
  } catch (error) {
    console.error(error)
  }
}

export async function searchOrdersNetting(objCriteria){
    try {
        let response = await genericGetWithBody('BNOrder/SearchOrderNetting',objCriteria);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function searchNettings(objCriteria){
    try {
        let response = await genericGetWithBody('BNOrder/SearchNettings',objCriteria);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function saveNetting(objNetting) {
  const method = 'POST'
  const apiName = 'BNOrder/SaveNetting'

  const response = await genericCallWithBodyAndResponseDecoded(
    method,
    apiName,
    objNetting,
  )
  return response
}

export async function getNettingByID(nettingID) {
  try {
    let params = {
      'nettingID': nettingID
    }

    let response = await genericGetWithParameters('BNOrder/GetNettingByID', params);
    return response;
  } catch (error) {
    console.error(error);
  }
}